const { construct } = require("ramda");

class ForbiddenError extends Error {
  constructor(message) {
    super(message);
    this.statusCode = 403;
    this.name = "ForbiddenError";
  }
}

module.exports = (msg) => construct(ForbiddenError)(msg);
